export const PERMISSION_RESOURCE_CODES = {
  home: 'home',
  analyticsOverview: 'analytics-overview',
  analyticsContractAnalysis: 'analytics-contract-analysis',
  analyticsPerformance: 'analytics-performance',
  contractsMine: 'contracts-mine',
  contractsAll: 'contracts-all',
  contractDetail: 'contract-detail',
  contractApproval: 'contract-approval',
  signingParties: 'signing-parties',
  permissionManagement: 'permission-management',
  contractTypes: 'contract-types',
  numberRules: 'number-rules',
} as const;

export const PERMISSION_ACTION_CODES = {
  contractsMine: { create: 'create' },
  contractsAll: { create: 'create' },
  contractDetail: {
    editContract: 'edit-contract',
    submitApproval: 'submit-approval',
    confirmSign: 'confirm-sign',
    activateContract: 'activate-contract',
    completeContract: 'complete-contract',
    terminateContract: 'terminate-contract',
    voidContract: 'void-contract',
    createParty: 'create-party',
    editParty: 'edit-party',
    deleteParty: 'delete-party',
    createItem: 'create-item',
    editItem: 'edit-item',
    deleteItem: 'delete-item',
    createFulfillment: 'create-fulfillment',
    editFulfillment: 'edit-fulfillment',
    completeFulfillment: 'complete-fulfillment',
    deleteFulfillment: 'delete-fulfillment',
    createSettlementPlan: 'create-settlement-plan',
    editSettlementPlan: 'edit-settlement-plan',
    readySettlementPlan: 'ready-settlement-plan',
    cancelSettlementPlan: 'cancel-settlement-plan',
    recognizeSettlementPlan: 'recognize-settlement-plan',
    deleteSettlementPlan: 'delete-settlement-plan',
    uploadNormalVersion: 'upload-normal-version',
    uploadSignedVersion: 'upload-signed-version',
    deleteVersion: 'delete-version',
    uploadAttachment: 'upload-attachment',
    deleteAttachment: 'delete-attachment',
  },
  contractApproval: { approve: 'approve', reject: 'reject' },
  signingParties: {
    create: 'create',
    edit: 'edit',
    enable: 'enable',
    disable: 'disable',
  },
  permissionManagement: { manage: 'manage' },
  contractTypes: {
    create: 'create',
    edit: 'edit',
    enable: 'enable',
    disable: 'disable',
  },
  numberRules: {
    create: 'create',
    edit: 'edit',
    enable: 'enable',
    disable: 'disable',
  },
} as const;

export const PERMISSION_ACCESS_KEYS = {
  createContract: 'canCreateContract',
  permissionManagement: 'canManagePermissions',
} as const;
